<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-pie-chart"></i> 作品统计</span>
      </div>

      <!-- 顶部统计卡片 -->
      <el-row :gutter="20" class="top-cards">
        <el-col :span="12">
          <div class="stat-card">
            <div>
              <div class="stat-num">{{ totalWorks }}</div>
              <div class="stat-label">作品数量</div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="stat-card">
            <div>
              <div class="stat-num">{{ totalAuthors }}</div>
              <div class="stat-label">作者数量</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 个人作品排行 -->
      <h3 class="section-title">个人作品排行</h3>
      <el-table
        :data="rankingData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="姓名" prop="name">
          <template slot-scope="scope">
            <span
              class="clickable-name"
              @click="goToWorksManagementByName(scope.row.name)"
            >
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="班级" prop="clazzName"></el-table-column>
        <el-table-column label="作品数量" prop="workCount"></el-table-column>
      </el-table>

      <!-- 图表区域 -->
      <el-row :gutter="20" style="margin-top: 30px">
        <el-col :span="12">
          <h3 class="section-title">作品班级占比</h3>
          <div ref="classChart" style="height: 300px"></div>
        </el-col>
        <el-col :span="12">
          <h3 class="section-title">作品空间占比</h3>
          <div ref="spaceChart" style="height: 300px"></div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {
  queryWorkAuthorCount,
  workRank,
  clazzRankRatio,
  spaceRankRatio,
} from "@/api/config";
import * as echarts from "echarts";

export default {
  data() {
    return {
      totalWorks: 0,
      totalAuthors: 0,
      rankingData: [],
      classData: [],
      spaceData: [],
      classChartInstance: null, // 保存班级图表实例
      spaceChartInstance: null, // 保存空间图表实例
      colors: [
        "#5B8FF9",
        "#61DDAA",
        "#65789B",
        "#F6BD16",
        "#7262fd",
        "#78D3F8",
        "#9661BC",
        "#F6903D",
        "#008685",
        "#F08BB4",
        "#8FD9FF",
        "#C2C8D5",
      ],
    };
  },
  mounted() {
    this.getData();
    this.getRank();
    this.getClazzRankRatio();
    this.getSpaceRankRatio();
  },
  methods: {
    // 跳转到作品管理页面
    goToWorksManagement(clazzName = null) {
      const query = {};
      if (clazzName) {
        // 对班级名称进行编码，防止特殊字符导致的问题
        query.clazzName = encodeURIComponent(clazzName);
      }
      this.$router.push({
        path: "/creative-space/work-manage",
        query: query,
      });
    },
    // 跳转到作品管理页面 - 通过作者姓名
    goToWorksManagementByName(authorName) {
      const query = {};
      if (authorName) {
        // 对作者姓名进行编码
        query.childName = encodeURIComponent(authorName);
      }
      this.$router.push({
        path: "/creative-space/work-manage",
        query: query,
      });
    },
    // 跳转到资源管理页面 - 通过空间名称
    goToResourceManagementBySpaceName(spaceName) {
      const query = {};
      if (spaceName) {
        // 对空间名称进行编码
        query.spaceName = encodeURIComponent(spaceName);
      }
      this.$router.push({
        path: "/config/supplier",
        query: query,
      });
    },
    getSpaceRankRatio() {
      spaceRankRatio().then((res) => {
        // 保存空间占比数据
        this.spaceData = res.map((item) => ({
          name: item.name,
          value: item.count,
          ratio: item.ratio,
        }));
        // 重新渲染空间占比饼图
        this.$nextTick(() => {
          this.spaceChartInstance = this.renderSpacePieChart(
            this.$refs.spaceChart,
            this.spaceData,
            "作品空间占比"
          );
        });
      });
    },
    getClazzRankRatio() {
      clazzRankRatio().then((res) => {
        // 保存班级占比数据
        this.classData = res.map((item) => ({
          name: item.name,
          value: item.count,
          ratio: item.ratio,
        }));
        // 重新渲染班级占比饼图
        this.$nextTick(() => {
          this.classChartInstance = this.renderClassPieChart(
            this.$refs.classChart,
            this.classData,
            "作品班级占比"
          );
        });
      });
    },
    getRank() {
      workRank().then((res) => {
        this.rankingData = res;
      });
    },
    getData() {
      queryWorkAuthorCount().then((res) => {
        this.totalAuthors = res.authorCount; // 所有的作品数量
        this.totalWorks = res.workCount; // 所有的作者数量
      });
    },
    renderClassPieChart(dom, data, title) {
      const chart = echarts.init(dom);
      const total = data.reduce((sum, item) => sum + item.value, 0);

      const option = {
        color: this.colors,
        tooltip: {
          trigger: "item",
          formatter: ({ name, value, ratio }) =>
            `${name}<br/>数量: ${value}<br/>占比: ${ratio.toFixed(2)}%`,
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: "middle",
          formatter: (name) => {
            const item = data.find((d) => d.name === name);
            if (!item) return name;
            const percent = item.ratio ? item.ratio.toFixed(2) : ((item.value / total) * 100).toFixed(2);
            return `${name}  ${item.value} (${percent}%)`;
          },
        },
        series: [
          {
            name: title,
            type: "pie",
            radius: ["40%", "70%"],
            center: ["40%", "50%"],
            data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      chart.setOption(option);

      // 添加点击事件监听
      chart.on("click", (params) => {
        // 点击班级图表时跳转到作品管理页面，并传递班级名称
        this.goToWorksManagement(params.name);
      });

      return chart;
    },
    renderSpacePieChart(dom, data, title) {
      const chart = echarts.init(dom);
      const total = data.reduce((sum, item) => sum + item.value, 0);

      const option = {
        color: this.colors,
        tooltip: {
          trigger: "item",
          formatter: ({ name, value, ratio }) =>
            `${name}<br/>数量: ${value}<br/>占比: ${ratio.toFixed(2)}%`,
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: "middle",
          formatter: (name) => {
            const item = data.find((d) => d.name === name);
            if (!item) return name;
            const percent = item.ratio ? item.ratio.toFixed(2) : ((item.value / total) * 100).toFixed(2);
            return `${name}  ${item.value} (${percent}%)`;
          },
        },
        series: [
          {
            name: title,
            type: "pie",
            radius: ["40%", "70%"],
            center: ["40%", "50%"],
            data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      chart.setOption(option);

      // 添加点击事件监听
      chart.on("click", (params) => {
        // 点击空间图表时跳转到资源管理页面，并传递空间名称
        this.goToResourceManagementBySpaceName(params.name);
      });

      return chart;
    },
    renderPieChart(dom, data, title) {
      const chart = echarts.init(dom);
      const total = data.reduce((sum, item) => sum + item.value, 0);

      chart.setOption({
        color: this.colors,
        tooltip: {
          trigger: "item",
          formatter: ({ name, value, percent }) =>
            `${name}<br/>数量: ${value}<br/>占比: ${percent.toFixed(2)}%`,
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: "middle",
          formatter: (name) => {
            const item = data.find((d) => d.name === name);
            if (!item) return name;
            const percent = ((item.value / total) * 100).toFixed(2);
            return `${name}  ${item.value} (${percent}%)`;
          },
        },
        series: [
          {
            name: title,
            type: "pie",
            radius: ["40%", "70%"],
            center: ["40%", "50%"],
            data,
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.top-cards {
  margin-bottom: 20px;
}
.stat-card {
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 20px;
}
.stat-icon {
  width: 60px;
  height: 60px;
  background: #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.stat-num {
  font-size: 28px;
  font-weight: bold;
}
.stat-label {
  font-size: 14px;
  color: #666;
}
.section-title {
  margin: 15px 0;
  font-weight: bold;
}
.top-cards {
  margin-bottom: 30px;
}

.stat-card {
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.stat-card:hover {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 24px;
  color: white;
}

.works-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.authors-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.stat-info {
  flex: 1;
}

.stat-num {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

/* 可点击的姓名样式 */
.clickable-name {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}

.clickable-name:hover {
  color: #66b1ff;
}
</style>
